// extracted by mini-css-extract-plugin
module.exports = {"container":"tab_container__KH7eo","paginator":"tab_paginator__UgdUv"};